import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const Form = styled.form`
  ${media.md`
    /* min-height: 400px; */
    /* background: red; */
  `}
`;

export const InlineWrapper = styled.div`
  display: inline-flex;
  svg {
    transform: translate(2px, -5px);
  }
`;

export const PopoverMessage = styled.div`
  background: grey;
  color: white;
  max-width: 250px;
  padding: 8px;
  border-radius: 6px;
  margin-bottom: 5px;
  font-family: ${({ theme }) => theme.bodyFont};
  font-size: 13px;
`;
